<template>
	<div class="user-avator-dropdown">
		<Button size="large" v-if="$store.state.app.currentPage=='weightSorting' ||
        $store.state.app.currentPage=='standardSorting' || $store.state.app.currentPage=='orderSorting'
		        || $store.state.app.currentPage=='diffSorting' || $store.state.app.currentPage=='preSorting'"
		        @click="doFlushPage">
			<Icon type="md-refresh"/>
			刷新
		</Button>
		<Dropdown @on-click="handleClick">
			<Badge :dot="false">
				<Avatar :src="$store.state.user.userInfo.head_img"/>
			</Badge>
			<b color="default">{{$store.state.user.userInfo.nick}}</b>
			<Icon :size="18" type="md-arrow-dropdown"/>
			<DropdownMenu slot="list">
				<DropdownItem name="personal-setting">
					<Icon type="ios-settings" :size="24" style="margin-bottom: 2px;"/>
					设置中心
				</DropdownItem>
				<DropdownItem name="turnoverList">
					<Icon type="ios-filing" :size="24" style="margin-bottom: 2px;"/>
					称重框管理
				</DropdownItem>
				<!--<DropdownItem name="password">
					<Icon type="md-unlock" :size="24" style="margin-bottom: 2px;"/>
					修改密码
				</DropdownItem>-->
				<DropdownItem name="logout">
					<Icon type="md-log-in" :size="24" style="margin-bottom: 2px;"/>
					退出登录
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>

	</div>
</template>

<script>
	import './user.less';
	import {logout} from '@/api/user/user';
	import {setToken,} from "@/libs/util";

	export default {
		name: 'User',
		inject: ["reloadContent"],
		data() {
			return {}
		},
		props: {
			userAvator: {
				type: String,
				default: ''
			},
			userName: {
				type: String,
				default: ''
			},
			messageUnreadCount: {
				type: Number,
				default: 0
			}
		},
		methods: {
			// 推出登录
			handleClick(name) {
				switch (name) {
					case 'personal-center':
						this.$router.push({name: 'personal-center'});
						break;
					case 'personal-setting':
						this.$router.push({name: 'setting'});
						break;
					case 'turnoverList':
						this.$router.push({name: 'turnoverList'});
						break;
					case 'logout':
						this.logout();
						break;
					case 'password':
						break
				}
			},
			logout() {
				let platformId = localStorage.getItem("currentPlatformId");
				let name = "login";
				// 关闭长连接
				if (this.$store.state.user.sseScore) {
					this.$store.state.user.sseScore.close();
				}
				// 调用退出登录方法
				logout();
				setToken("");
				this.$router.push({
					name: name,
					params: {platformId: platformId}
				})
			},
			// 刷新页面
			doFlushPage() {
				this.reloadContent();
			}
		}
	}
</script>

<style lang="less">
	.user-avator-dropdown .ivu-select-dropdown {
		z-index: 999;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue